import useMedalMultiSelect from './UseMedalMultiSelect';

import MultiSelect from '../MultiSelect';

const CourseMultiSelect = ({ label, name, value, error, message, onChange }) => {
  const { options } = useMedalMultiSelect();

return (
  <MultiSelect
    label={label}
    name={name}
    value={value}
    options={options}
    error={error}
    message={message}
    isLoading={false}
    onChange={onChange}
  />
);
}

export default CourseMultiSelect;